import { z } from 'zod';
import { ingredientCategorySchema } from '../constants/categories.js';
// ---------------------------------------------------------------------------
// Shopping List
// ---------------------------------------------------------------------------
export const ShoppingListSchema = z.object({
    id: z.string().uuid(),
    family_id: z.string().uuid(),
    meal_dates: z.array(z.string().date()),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
// ---------------------------------------------------------------------------
// Shopping List Item
// ---------------------------------------------------------------------------
export const ShoppingListItemSchema = z.object({
    id: z.string().uuid(),
    list_id: z.string().uuid(),
    name: z.string().min(1),
    quantity: z.number().positive().nullable().default(null),
    unit: z.string().nullable().default(null),
    category: ingredientCategorySchema.default('other'),
    checked: z.boolean().default(false),
    checked_by: z.string().uuid().nullable().default(null),
    checked_at: z.string().datetime().nullable().default(null),
    recipe_ids: z.array(z.string().uuid()).default([]),
    is_manual: z.boolean().default(false),
    is_modified: z.boolean().default(false),
    ingredient_ref_id: z.string().uuid().nullable().default(null),
});
//# sourceMappingURL=shopping-list.js.map